import { render } from "./attached-documents.vue?vue&type=template&id=8903c810"
import script from "./attached-documents.vue?vue&type=script&lang=js"
export * from "./attached-documents.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__